import React from 'react'

import Navbar from '../Components/Navbar'
import ButtWeldFittingsDetails from '../Components/ButtWeldFittingsDetails'
import Footer from '../Components/Footer'

const ButtWeldFittings = () => {
  return (
    <div>
      <Navbar />
      <ButtWeldFittingsDetails />
      <Footer />
    </div>
  )
}

export default ButtWeldFittings